import { z } from 'zod';

const CurrencySchema = z.object({
  value: z.string(),
  displayName: z.string(),
  sign: z.string(),
});

const GoalSchema = z.object({
  id: z.number(),
  metric: z.coerce.number(),
  metricLabel: z.string(),
  isPrimary: z.boolean(),
  value: z.number(),
  goalValue: z.coerce.number(),
  valueType: z.string(),
  justAdded: z.optional(z.boolean()),
  objective: z.optional(z.enum(['awareness', 'all', 'performance'])),
  isNew: z.optional(z.boolean()),
});

const TileSchema = z.object({
  id: z.string().or(z.number()),
});

const CampaignsSchema = z.object({
  displayCampaign: z.array(TileSchema).optional(),
  ghostCampaign: z.array(TileSchema).optional(),
  searchCampaign: z.array(TileSchema).optional(),
  socialCampaign: z.array(TileSchema).optional(),
  videoCampaign: z.array(TileSchema).optional(),
  emailCampaign: z.array(TileSchema).optional(),
});

const MediaSchema = z.object({
  id: z.number(),
  name: z.string(),
  file: z.string(),
  uploadedAt: z.string(),
  type: z.enum(['Presentation', 'Video', 'Banner']),
});

const AdServersEnum = z.enum([
  'adform_ad_server',
  'campaign_manager',
  'appsflyer_ad_server',
  '',
]);

export const CampaignSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  adServer: AdServersEnum,
  published: z.boolean(),
  description: z.string(),
  currency: CurrencySchema,
  budget: z.string().nullable(),
  allocatedBudget: z.coerce.number(),
  dateFrom: z.string().or(z.null()),
  dateTo: z.string().or(z.null()),
  budgetSpent: z.coerce.number().nullable(),
  status: z.string(),
  goals: z.array(GoalSchema),
  campaigns: CampaignsSchema,
  media: z.array(MediaSchema).optional(),
});

export const CampaignTitleSchema = z.object({
  title: z.string(),
});

export type CampaignType = z.infer<typeof CampaignSchema>;
export type CampaignTitleType = z.infer<typeof CampaignTitleSchema>;
